class TeamMember extends DrupalBehavior {
    onContent(context) {
        const truncateContent = () => {


            once('teamMemberTruncateContent', '.team-member', context).forEach(function(item) {

                let body = item.querySelector('.team-member--bio-inner').textContent;

                if (body.length > 200) {
                    let container = item.querySelector('.team-member--bio');

                    let innerText = item.querySelector('.team-member--bio-inner');
                    innerText.classList.add('hide');
                    gsap.to(innerText, { duration: .5, ease: 'power4.out', height: '48'});

                    // button
                    const showButton = document.createElement(`a`);
                    showButton.classList.add(`show-more`);
                    showButton.innerText = `Show More`;

                    showButton.addEventListener(`click`, function() {
                        innerText.classList.toggle(`hide`)
                        if (innerText.classList.contains(`hide`)) {
                            showButton.textContent = `Show More`;
                            gsap.to(innerText, { duration: 0.4, ease: 'power4.out', height: '48'});
                        } else {
                            showButton.textContent = `Show Less`;
                            gsap.to(innerText, { duration: 0.4, ease: 'power4.out', height: 'auto'});
                        }
                    });
                    container.appendChild(showButton);
                }
            });
        }

        truncateContent();
    }
}

DrupalBehavior.register('summit_theme', 'team_member', TeamMember);